import { ButtonProps } from '@shared/ui/kit/button/model/types';
import { FC } from 'react';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { PlusIcon } from '@shared/assets/icons';

export const AddButton: FC<ButtonProps> = ({ children, onClick, settings }, props) => {
  return (
    <button onClick={onClick} {...stylex.props(styles.btn)} settings={settings} {...props}>
      <span {...stylex.props(styles.icon)}>
        <PlusIcon />
      </span>
      <span {...stylex.props(styles.children)}>{children}</span>
    </button>
  );
};
